import { useTranslation } from 'next-i18next'
import { PaymentInterval } from '../../model'
import { useCheckoutState, usePaymentInterval } from '../../state'
import { FirstPaymentType } from '@afterpaytouch/portal-api'

export const RenderPaymentIntervalText = (index: number): string => {
  const { t } = useTranslation()
  const { firstPaymentType } = useCheckoutState()
  const paymentIntervalType = usePaymentInterval()
  const npufPaymentType = firstPaymentType === FirstPaymentType.NoPaymentUpfront

  if (index === 0) {
    return paymentIntervalType === PaymentInterval.FORTNIGHTLY ? t('common:week', { count: 2 }) : t('common:month', { count: 1 })
  }
  const shouldShowMonthPlural = (index === 1 && npufPaymentType) || index > 1
  return paymentIntervalType === PaymentInterval.FORTNIGHTLY ? t('common:week', { count: 2 }) : t('common:month', { count: shouldShowMonthPlural ? 2 : 1 })
}

export const getNumberWithOrdinal = (n: number): string => {
  const s = ['th', 'st', 'nd', 'rd']
  const v = n % 100
  return String(n) + (s[(v - 20) % 10] || s[v] || s[0])
}
